import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import { archiveDataResponse } from 'mocks/mockData/archiveData';

export const postArchiveDataHandler: RestHandler[] = [
  rest.post(PATHS.getArchiveUrlPath('*', 'pdf', 'Check'), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(archiveDataResponse))
  )
];
